import { Button } from "@/components/ui/Button";
import { Locale } from "@/enums/common.enum";
import { Link } from "@/i18n/routing";
import { Sitemap } from "@/interfaces/sitemap.interface";
import clsx from "clsx";
import { startCase } from "lodash";
import { useLocale, useTranslations } from "next-intl";
import { useEffect, useMemo, useState } from "react";

export const PopularSearchLinkContainer = ({
  sitemaps,
  truncate = true,
}: {
  sitemaps: Array<Sitemap>;
  truncate: boolean;
}) => {
  const st = useTranslations("shared.words");
  const locale = useLocale() as Locale;

  const [showAllLinks, setShowAllLinks] = useState(false);

  const handleClick = () => setShowAllLinks((prev) => !prev);

  const truncSitemap = useMemo(() => {
    if (showAllLinks) {
      return sitemaps;
    } else if (truncate) {
      return sitemaps.slice(0, 10);
    }

    return sitemaps;
  }, [truncate, sitemaps, showAllLinks]);

  useEffect(() => {
    if (sitemaps.length <= 5) {
      setShowAllLinks(true);
    }
  }, [sitemaps]);

  return (
    <div className="flex flex-col gap-1 items-start">
      <div
        className={clsx(
          "flex flex-col gap-4 overflow-hidden transition-transform relative",
          {
            "h-52": !showAllLinks && truncate,
            "h-full": sitemaps.length <= 5 || !truncate,
          }
        )}
      >
        {truncSitemap.map((sitemap) => (
          <Link
            href={`/listing/${sitemap[locale]?.slug}`}
            className="text-sm"
            key={sitemap[locale]?.slug}
            prefetch={false}
          >
            {startCase(sitemap[locale]?.slug.split("-").join(" "))}
          </Link>
        ))}
        {!showAllLinks && truncate && (
          <div className="absolute bottom-0 left-0 w-full h-7 bg-gradient-to-t from-white to-transparent pointer-events-none" />
        )}
      </div>
      {sitemaps.length > 5 && truncate && (
        <Button onClick={handleClick} variant={"outline"}>
          {showAllLinks ? st("view-less") : st("view-more")}
        </Button>
      )}
    </div>
  );
};
